import PageDependencies from "../../../Feature/PageDependencies";
import { connectAppStore } from "../../../Store/AppStore";
import "./ReleaseLogs.css";
import ReleaseLog from "./ReleaseLog";
const ReleaseLogs = (props) => {
    const {
        getData,
        tryCatchFinally,
        useState,
        guid,
        layoutManager,
        useEffect
    } = PageDependencies();

    const [logs, setLogs] = useState([]);
    const getUrl = "/api/ReleaseLog";
    const LoadLogs = async () => {
        const response = await getData.processPost(false, getUrl, {});
        if(response.state === true){
            for(let i=0; i<response.releaseLogs.length; i++){
                if (i===0){
                    response.releaseLogs[i].releaseDateString = response.releaseLogs[i].releaseDateString + " (Latest version)";
                }
            }
            setLogs(response.releaseLogs);
        }
    }
    useEffect(()=>{
        tryCatchFinally.syncProcess(()=>{
            layoutManager.Layout_HideHeadter_Footer_HideSideBar(props);
            LoadLogs();
        });
    },[])
    return <>
        <div className="app-main__inner">
            <div className="app-page-title">
                <div className="page-title-wrapper">
                    <div className="page-title-heading">
                        <div className="page-title-icon">
                            <i className="pe-7s-ticket icon-gradient bg-tempting-azure">
                            </i>
                        </div>
                        <div>
                            Release Logs
                            <div className="page-title-subheading">
                                These release logs provide information about all the updates
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {logs.map(l=>{
                return<div key = {guid.newGuid()}>
                    <ReleaseLog item = {l}></ReleaseLog>
                </div>
            })}
        </div>
    </>;
}

export default connectAppStore(ReleaseLogs);